"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var G = tslib_1.__importStar(require("@antv/g"));
var g2_1 = require("@antv/g2");
var _ = tslib_1.__importStar(require("@antv/util"));
// 记录之前的状态
var shapeCache;
function clipInFromCenter(shape, animateCfg) {
    var bbox = shape.getBBox();
    var centerX = bbox.minX + bbox.width / 2;
    var cliper = new G.Rect({
        attrs: {
            x: centerX,
            y: bbox.minY,
            width: 0,
            height: bbox.height,
        },
    });
    shape.attr('clip', cliper);
    cliper.animate({
        width: bbox.width,
        x: bbox.minX,
    }, animateCfg.duration, animateCfg.easing, function () {
        shape.attr('clip', null);
    }, animateCfg.delay);
}
clipInFromCenter.animationName = 'clipInFromCenter';
function setShapeCache(shapes) {
    shapeCache = shapes;
}
exports.setShapeCache = setShapeCache;
function updateFromCenter(shape, animateCfg) {
    var fromPath = getShapeFromCache(shape).attr('path');
    var toPath = _.clone(shape.attr('path'));
    shape.attr('path', fromPath);
    shape.animate({
        path: toPath,
    }, animateCfg.duration, animateCfg.easing, animateCfg.callback, 100);
}
function getShapeFromCache(shape) {
    var id = shape.id;
    var target;
    _.each(shapeCache, function (s) {
        if (s.id === id) {
            target = s;
        }
    });
    return target;
}
updateFromCenter.animationName = 'updateFromCenter';
g2_1.Animate.registerAnimation('appear', 'clipInFromCenter', clipInFromCenter);
g2_1.Animate.registerAnimation('update', 'updateFromCenter', updateFromCenter);
//# sourceMappingURL=animation.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/plots/range-bar/animation.js
// module id = 954
// module chunks = 37